import { RoutePaths } from 'common-types';
import { FunctionComponent, SVGProps } from 'react';

export type TPageData = {
  title: string;
  href: RoutePaths;
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
};

export const isNavLinkActive = (pathname: string, href: string): boolean => {
  const isExactMatch = pathname === href;
  const isPartialMatch = pathname.includes(href) && href !== RoutePaths.HOME;
  const isBookmarksOnInsights = href === RoutePaths.INSIGHTS && pathname.startsWith(RoutePaths.BOOKMARKS);
  const isArticleOnInsights = href === RoutePaths.INSIGHTS && pathname.startsWith(RoutePaths.ARTICLE);

  return isExactMatch || isPartialMatch || isBookmarksOnInsights || isArticleOnInsights;
};
